import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/Navbar.css";

const Navbar = ({ userRole, onLogout }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return (
    <nav className="navbar">
      <ul className="nav-links">
        {!userRole && <li><Link to="/">Home</Link></li>}
        {userRole === "PRIMARY" && (
          <>
            <li><Link to="/change-password">Change Password</Link></li>
            <li><Link to="/ownerdashboard">Dashboard</Link></li>
            <li><Link to="/AgentForm">Register</Link></li>
            <li><Link to="/BulkAgentForm">Bulk Register</Link></li>
            <li><Link to="/last-login">Last Login</Link></li>
          </>
        )}
        {userRole === "SECONDARY" && (
          <>
            <li><Link to="/change-password">Change Password</Link></li>
            <li><Link to="/ownerdashboard">Dashboard</Link></li>
            <li><Link to="/last-login">Last Login</Link></li>
          </>
        )}
        {userRole === "AGENT" && (
          <>
            <li><Link to="/change-password">Change Password</Link></li>
            <li><Link to="/agentdashboard">Dashboard</Link></li>
            <li><Link to="/FileUpload">Generate PDF</Link></li>
            <li><Link to="/last-login">Last Login</Link></li>
          </>
        )}
        {userRole && (
          <li>
            <Link to="/" onClick={onLogout}>
              Logout
            </Link>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Navbar;